<script setup lang="ts">
defineProps<{
  countries: Country[];
}>();

const { t } = useI18n();

const selectedCountry = defineModel<Country | undefined>("selectedCountry");
// const aboutBusiness = defineModel<string>("aboutBusiness");
const businessName = defineModel<string>("businessName");
</script>

<template>
  <div class="flex flex-col justify-center items-center space-y-1 lg:space-y-3">
    <h2 class="text-default-500 font-bold text-center text-2xl lg:text-[40px] leading-[30px] lg:leading-[46px]">{{ t('page.create_business.business_details.title') }}</h2>
    <span class="text-overcast-night font-medium text-wrap text-center text-sm lg:text-lg">{{ t('page.create_business.business_details.desc') }}</span>
  </div>
  <div class="flex-1 flex flex-col space-y-3 gap-y-2 mt-10 w-full">
    <UFormGroup :label="t('label.business_name')" name="business_name" size="xl">
      <UInput v-model="businessName" type="text" :placeholder="t('placeholder.business_name')" size="xl" />
    </UFormGroup>
    <UFormGroup :label="t('label.country')" name="country_id" size="xl">
      <USelectMenu
          v-model="selectedCountry"
          :options="countries"
          :ui="{ rounded: 'rounded-lg' }"
          by="id"
      >
        <template #empty>
          {{ t('no_countries') }}
        </template>
        <template #label>
          <div v-if="selectedCountry" class="flex items-center overflow-hidden">
            <img class="size-6 rounded-md" :src="selectedCountry?.image" :alt="selectedCountry?.name" > <span class="capitalize ml-1.5 mr-1">{{ selectedCountry?.name }}</span>
          </div>
          <span v-else class="text-gray-400">{{ t('placeholder.select_country') }}</span>
        </template>
        <template #option="{option}">
          <div class="flex items-center overflow-hidden">
            <img class="size-6 rounded-md" :src="option?.image" :alt="option?.name" > <span class="capitalize ml-1.5 mr-1">{{ option?.name }}</span>
          </div>
        </template>
      </USelectMenu>
    </UFormGroup>
    <!-- <UFormGroup :label="t('label.about_business')" name="phone_number" size="xl">
      <CommonTextarea v-model="aboutBusiness" resize :rows="10" :max-length="1000" :placeholder="t('placeholder.about_business')" />
    </UFormGroup> -->
  </div>
</template>
